import styled from 'styled-components'

// ============================================
// Container with CSS Container Queries
// ============================================

export const DashboardContainer = styled.div`
  container-name: summary;
  container-type: inline-size;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const DashboardContent = styled.div`
  margin: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  display: flex;
  flex-direction: column;
  gap: 12px;
`

// ============================================
// Section 1: Hero Summary Bar
// ============================================

export const HeroBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @container summary (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const ScoresRow = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  width: 100%;
  justify-content: space-between;

  @container summary (max-width: 700px) {
    flex-wrap: wrap;
  }

  @container summary (max-width: 500px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

export const ScoreMiniCard = styled.div<{ $clickable?: boolean }>`
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 8px 12px;
  flex: 1;
  min-width: 88px;
  text-align: left;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ $clickable, theme }) =>
      $clickable
        ? theme.colors.border.light
        : theme.colors.background.secondary};
  }
`

export const ScoreMiniValue = styled.div<{ $color: string }>`
  font-size: 20px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  display: inline;
`

export const ScoreMiniMax = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const ScoreMiniBar = styled.div`
  height: 3px;
  background: ${({ theme }) => theme.colors.border.light};
  border-radius: 2px;
  overflow: hidden;
  margin: 4px 0 2px;
`

export const ScoreMiniFill = styled.div<{ $color: string }>`
  height: 100%;
  background: ${({ $color }) => $color};
  transition: width 0.6s ease;
  border-radius: 2px;
`

export const ScoreMiniLabel = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.2;
`

// Ownership section

export const OwnerLastChange = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const OwnerChipsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
`

export const OwnerChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: 5px 10px;
  min-width: 0;
`

export const OwnerName = styled.span<{ $clickable?: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: 500;
  color: ${({ $clickable, theme }) =>
    $clickable ? theme.colors.primary : theme.colors.text.primary};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  &:hover {
    text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
  }
`

export const OwnerActions = styled.div`
  display: flex;
  gap: 3px;
  flex-shrink: 0;
`

export const OwnerActionBtn = styled.button<{
  $variant: 'google' | 'linkedin' | 'local' | 'zefix'
}>`
  border: none;
  border-radius: 3px;
  padding: 2px 4px;
  cursor: pointer;
  font-size: 8px;
  font-weight: 600;
  color: white;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;

  background: ${({ $variant }) => {
    switch ($variant) {
      case 'google':
        return '#DB4437'
      case 'linkedin':
        return '#0077B5'
      case 'local':
        return '#ffffff'
      case 'zefix':
        return '#D52B1E'
    }
  }};

  ${({ $variant }) =>
    $variant === 'local' &&
    `
    color: #333;
    border: 0.5px solid #ddd;
    font-size: 7px;
  `}

  &:hover {
    opacity: 0.85;
  }
`

export const ShowMoreToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px;
  margin: 0 12px 10px;
  width: calc(100% - 24px);
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  transition: background ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.border.light};
  }
`
